export const ArrowRightIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83887 5.16113L1.28613 0.608398L0.161133 1.7334L3.58887 5.16113L0.161133 8.58887L1.28613 9.71387L5.83887 5.16113Z"
      fill="currentColor"
    />
  </svg>
);
